export default __webpack_public_path__ + "static/media/booch-info.1fb98ccc.png";